export const useAppRunningContext = () => {
  return {
    withinIframe: window.parent !== window.self,
  }
}
